import { render, staticRenderFns } from "./AssetRow.vue?vue&type=template&id=31e6a5f8&scoped=true"
import script from "./AssetRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetRow.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e6a5f8",
  null
  
)

export default component.exports